// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"b716c3aa","84":"a4bcd9d5","178":"09989d16","567":"a9be1e46"}[chunkId] + ".chunk.js";
};